import { differenceInDays, startOfDay } from "date-fns";

export const sortByClosestToToday = <T, K extends keyof T>(
	items: T[],
	dateProperty: K,
): T[] => {
	const today = startOfDay(new Date());

	return [...items].sort((a, b) => {
		const aRaw = a[dateProperty];
		const bRaw = b[dateProperty];
		const aDate = aRaw ? new Date(aRaw as string) : null;
		const bDate = bRaw ? new Date(bRaw as string) : null;

		if (!aDate && !bDate) return 0;
		if (!aDate) return 1;
		if (!bDate) return -1;

		return (
			Math.abs(differenceInDays(today, aDate)) -
			Math.abs(differenceInDays(today, bDate))
		);
	});
};
